import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-find-near-me.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';
import tuftsSearchBarCssLit from '../tufts-search-bar/tufts-search-bar.css.lit';

/**
 * The tuftsFindNearMe component
 * @element tufts-find-near-me
 *
 * @slot heading
 */
@customElement('tufts-find-near-me')
export class tuftsFindNearMe extends OutlineElement {
  static styles: CSSResultGroup = [
    componentStyles,
    tuftsHeadingCssLit,
    tuftsSearchBarCssLit,
  ];
  ngSlot = new SlotNGController(this);
  resizeController: ResizeController = new ResizeController(this);
  isMobile: boolean;
  @property({ type: String, attribute: 'url-target' })
  urlTarget: string;
  @property({ type: String, attribute: 'added-input' })
  inputParam: string;
  @property({ type: String, attribute: 'added-param' })
  additionalParam: string;

  handleFormSubmit(event: Event) {
    event.preventDefault(); // Prevent the default form submission
    const form = event.target as HTMLFormElement;
    const userInput = form.querySelector('#edit-text') as HTMLInputElement;

    // Create a hidden input field to hold the input value
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'y_input';
    const userInputValue = userInput.value || '';
    const inputParamValue = this.inputParam || '';
    hiddenInput.value =
      userInputValue && inputParamValue
        ? `${userInputValue} + ${inputParamValue}`
        : userInputValue || inputParamValue;

    // Append the hidden input to the form
    if (this.inputParam !== this.additionalParam) {
      form.appendChild(hiddenInput);
    }

    // Create a hidden input field to additionalParam
    if (this.additionalParam) {
      const hiddenInputAdditionalParam = document.createElement('input');
      hiddenInputAdditionalParam.type = 'hidden';
      hiddenInputAdditionalParam.name = 'y_f_c_specialtyFAD.name';
      hiddenInputAdditionalParam.value = this.additionalParam;
      form.appendChild(hiddenInputAdditionalParam);
    }

    // Now you can submit the form with the modified data
    form.submit();

    // Remove the hidden input after submission
    form.removeChild(hiddenInput);
  }

  render(): TemplateResult {
    this.isMobile = this.resizeController.currentBreakpointRange === 0;
    const wrapperClasses = {
      'main-wrapper': true,
      'mobile': this.isMobile,
    };
    return html`
      <div class=${classMap(wrapperClasses)}>
        <tufts-icon
          name="magnifying-map-pin"
          library="system"
          size="64px"
        ></tufts-icon>
        <div class="content-wrapper">
          ${this.ngSlot.conditionalNGSlot('heading', true, 'md')}
          <div class="content">
            <tufts-search-bar>
              <form
                action="${this.urlTarget}"
                method="get"
                accept-charset="UTF-8"
                @submit="${this.handleFormSubmit}"
              >
                <div
                  class="js-form-item form-item js-form-type-textfield form-item-text js-form-item-text"
                >
                  <label for="edit-text" class="form-item__label font-body"
                    >Search</label
                  >
                  <input
                    data-drupal-selector="edit-text"
                    type="text"
                    id="edit-text"
                    name="y_input"
                    size="60"
                    maxlength="128"
                    class="form-text form-element form-element--type-text form-element--api-textfield"
                    placeholder="Enter your location"
                  />
                </div>
                <div
                  data-drupal-selector="edit-actions"
                  class="form-actions js-form-wrapper form-wrapper"
                  id="edit-actions"
                >
                  <button
                    class="button--primary button js-form-submit form-submit"
                    data-drupal-selector="edit-submit-locations-search"
                    type="submit"
                    id="edit-submit-locations-search"
                    value="Apply"
                  >
                    <tufts-icon
                      aria-hidden="true"
                      name="search"
                      library="system"
                      size="1.4em"
                    >
                    </tufts-icon>
                    <span class="visually-hidden">Apply</span>
                  </button>
                </div>
              </form>
            </tufts-search-bar>
            <tufts-button
              button-url="${this.urlTarget}"
              button-label="get my current location"
              button-variant="primary outlined"
              button-size="medium"
              icon-type=""
            >
              <tufts-icon
                name="target"
                library="system"
                label="More information"
                size="24px"
              ></tufts-icon>
              Use my current location
            </tufts-button>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-find-near-me': tuftsFindNearMe;
  }
}
